import { get } from 'lodash';

import { defineDefaultEnumValue } from 'src/lib/enum';

/**
 * Insights interval days
 * @property {INSIGHTS_INTERVAL_DAYS} DEFAULT - default page view
 */
export const INSIGHTS_INTERVAL_DAYS = {
  today: 'today',
  yesterday: 'yesterday',
  oneWeeks: 'one_weeks',
  allTime: 'all_time',
} as const;
export type InsightsIntervalDays =
  (typeof INSIGHTS_INTERVAL_DAYS)[keyof typeof INSIGHTS_INTERVAL_DAYS];
defineDefaultEnumValue(INSIGHTS_INTERVAL_DAYS, INSIGHTS_INTERVAL_DAYS.allTime);

const INSIGHTS_INTERVAL_DAYS_PROPS = {
  [INSIGHTS_INTERVAL_DAYS.today]: {
    label: 'Published today',
    value: 0,
  },
  [INSIGHTS_INTERVAL_DAYS.yesterday]: {
    label: 'Published yesterday',
    value: 1,
  },
  [INSIGHTS_INTERVAL_DAYS.oneWeeks]: {
    label: 'Published in the last 7 days',
    value: 7,
  },
  [INSIGHTS_INTERVAL_DAYS.allTime]: {
    label: 'Published all time',
    value: null,
  },
};

export const getInsightsIntervalDaysLabel = (insightsIntervalDays: InsightsIntervalDays): string =>
  get(INSIGHTS_INTERVAL_DAYS_PROPS, [insightsIntervalDays, 'label']) || '';

export const getInsightsIntervalDaysValue = (
  insightsIntervalDays: InsightsIntervalDays
): number | null => get(INSIGHTS_INTERVAL_DAYS_PROPS, [insightsIntervalDays, 'value']);
